import React from "react";
import styles from "../styles/components/Loading.module.css";

const Loading = ({ messageIndex = null }) => {
  const messages = [
    "Generating Character",
    "Generating 3D Model",
    "Rigging Character",
    "Generating Image",
    "Failed",
  ];

  return (
    <div className={styles.loaderContent}>
      {messageIndex !== 4 &&
        <div className={styles.loader}></div>
      }

      {messageIndex == null ? (
        <></>
      ) : (
        <>
          <p className={styles.message}>{`${messages[messageIndex]}`}</p>
          {messageIndex !== 4 &&
            <p className={styles.readySoon}>Ready soon</p>
          }
        </>
      )}
    </div>
  );
};

export default Loading;
